import { createFileRoute } from '@tanstack/react-router';

import { devOnlyGuard } from './-dev-only.js';

/**
 * Dev-only route that throws during render, exercising the error boundary
 * end-to-end: route crash → RethrowToAppErrorBoundary → AppErrorBoundary →
 * AppCrashPanel (+ Sentry). `devOnlyGuard` redirects to /login in production.
 * Paired with the `disableGlobalCatchBoundary` setting in router.tsx.
 */
function CrashTrigger(): never {
  throw new Error('Intentional render crash from the dev-only /test/crash route');
}

export const Route = createFileRoute('/test/crash')({
  beforeLoad: devOnlyGuard,
  component: CrashTrigger,
});
